import { ToastMessage } from './../../providers/toast-message';
import { ModelMetier } from './../../providers/model-metier';
import { DebugPage } from './../debug/debug';
import { UsersPage } from './../users/users';
import { CloudsPage } from './../clouds/clouds';
import { Login } from './../login/login';
import { AuthData } from './../../providers/auth-data';
import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';

/**
 * Generated class for the OthersPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@Component({
  selector: 'page-others',
  templateUrl: 'others.html',
})
export class OthersPage {

  constructor(public navCtrl: NavController, public navParams: NavParams, public loadingCtrl: LoadingController, 
              public authData: AuthData, public modelMetier: ModelMetier,
              public toastMessage : ToastMessage) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad OthersPage');
  }


  clouds() {
    this.navCtrl.push(CloudsPage);
  }


  users() {
    this.navCtrl.push(UsersPage);
  }


  refresh() {

    // let loader = this.loadingCtrl.create({
    //   content: "Start refresh from licIdTagValue,<p>Please wait...",
    // });
    // loader.present();

    // // this.toastMessage.message('Start refresh from licIdTagValue, please wait');

    // this.modelMetier.analyseAllDbStorage().then( () => {
    //    loader.dismiss();
    //   this.toastMessage.success('Refresh from licIdTagValue finish.');
    // }).catch((err) => {
    //   loader.dismiss();
    //   this.toastMessage.error('Refresh from licIdTagValue error: ' + err);
    // });
  }


  debug() {
    this.navCtrl.push(DebugPage);
  }


  logOut() {
    this.authData.logoutUser().then(() => {
        this.navCtrl.setRoot(Login);
    });
  }


}



// WEBPACK FOOTER //
// ./src/pages/others/others.ts